import React, { useMemo } from 'react';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useStatesQuery } from '@uplift/queries';
import { Spinner } from '@uplift/ui-v2';

const useStyles = makeStyles({ name: 'WhatStatesArticle' })(theme => ({
  list: {
    listStyleType: 'disc',
    paddingLeft: theme.spacing(3),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  listItem: {
    display: 'list-item',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: 0,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  listItemText: {
    margin: 0,
  },
  paragraph: {
    marginBottom: theme.spacing(1.5),
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4, 0),
  },
}));

export const WhatStatesArticle: React.FC = () => {
  const { classes } = useStyles();
  const { data: states = [], isLoading } = useStatesQuery();

  const availableStates = useMemo(
    () => states
      .filter(state => state.available)
      .sort((a, b) => a.fullName.localeCompare(b.fullName)),
    [states],
  );

  if (isLoading) {
    return (
      <Box className={classes.loading}>
        <Spinner />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="body1" className={classes.paragraph}>
        We do virtual therapy, psychiatric consultations, and medication management in:
      </Typography>
      <List className={classes.list} disablePadding>
        {availableStates.map(state => (
          <ListItem key={state.id} className={classes.listItem} disableGutters>
            <ListItemText
              className={classes.listItemText}
              primary={state.fullName}
              primaryTypographyProps={{ variant: 'body1' }}
            />
          </ListItem>
        ))}
      </List>
      <Typography variant="body1" className={classes.paragraph}>
        We&apos;re working to add more states and will update this list as we expand.
      </Typography>
    </Box>
  );
};
